module.exports = __webpack_public_path__ + "static/media/substancepainter.9ecdbe0f.png";